import React, { useEffect, useContext } from "react";
import Slider from "Components/deliverySlider/DeliverySlider";
import cx from "classnames";
import ResourceAdder from "Components/resourceAdder/ResourceAdder";
import useDeliveryPrices from "Utils/useDeliveryPrices";
import t from "Utils/translation";
import { deliveryPlans } from "@/config";
import formatCurrency from "Utils/formatCurrency";
import Loader from "Components/loader/Loader";

const formatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, {
  maximumFractionDigits: 0,
});

const ExtradeliverySelection = ({ isReseller, extraPackagesPricing, onChange, value }) => {
  const basicPricing = extraPackagesPricing.quantificable
    ? extraPackagesPricing.unit_pricing_eur
    : extraPackagesPricing.pricing_eur;

  return (
    <>
      <div className="flex justify-between">
        <div className="">
          <p className="text-[--text-a60] text-sm">{t("delivery.accounts.extradelivery.purchase")}</p>
          <p className="text-[--text-a40] text-xs">{t("delivery.accounts.extradelivery.minimumOrder")}</p>
        </div>
        <ResourceAdder name="volume" onChange={onChange} value={value} />
      </div>
      <div className="mt-6 border-0 border-t border-solid border-[--bg-d5]">
        <div className="flex justify-between py-2">
          <p className="font-semibold">{t("detailInfo.label.totalPrice")}</p>
          <p className="font-semibold">
            <span
              className={cx({
                "line-through": isReseller,
              })}
            >
              {formatCurrency(value * basicPricing)}
            </span>

            {isReseller && (
              <span className="ml-2 text-[--accent]">-{extraPackagesPricing.reseller_tier.discount_percent}%</span>
            )}
          </p>
        </div>
        {isReseller && (
          <div className="flex justify-between py-2">
            <p className="font-semibold">{t("label.billing.resellerPrice")}</p>
            <p className="font-semibold">{formatCurrency(value * extraPackagesPricing.reseller_tier.pricing_eur)}</p>
          </div>
        )}
      </div>
    </>
  );
};

const DeliveryVolumeSelection = ({
  showSlider = false,
  volumeValue,
  priceValue,
  hidePrices,
  resellerPriceValue,
  vatMsg,
  onChange,
  formValue,
  className,
  name,
  sliderMarks,
  title,
  info,
  isExtradelivery = false,
  accountData,
  plan,
  isReseller,
}) => {
  const { prices, getExtraPack } = useDeliveryPrices();
  let extraPackagesPricing = null;
  if (accountData) {
    extraPackagesPricing = getExtraPack(accountData.type);
  }

  let volumeLabel;
  let priceLabel;
  let resellerPriceLabel;

  if (plan === deliveryPlans.FREE) {
    volumeLabel = t("delivery.accounts.add.stepPlan.monthlyNumberOfMessages");
    priceLabel = t("delivery.accounts.add.stepPlan.monthlyPrice");
  }

  if (plan === deliveryPlans.MONTHLY) {
    volumeLabel = t("delivery.accounts.add.stepPlan.monthlyNumberOfMessages");
    priceLabel = t("delivery.accounts.add.stepPlan.monthlyPrice");
    resellerPriceLabel = t("delivery.accounts.add.stepPlan.monthlyResellerPrice");
  }

  if (plan === deliveryPlans.PREPAID) {
    volumeLabel = t("delivery.accounts.add.stepPlan.numberOfMessages");
    priceLabel = t("delivery.accounts.add.stepPlan.price");
    resellerPriceLabel = t("delivery.accounts.add.stepPlan.resellerPrice");
  }

  if (!prices) {
    return (
      <div className={cx(className, "w-full")}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={cx(className, "w-full")}>
      <div>
        <div className="settingTitle">{title}</div>
        {info && <div className="sectionInfo">{info}</div>}
      </div>
      {isExtradelivery ? (
        <ExtradeliverySelection
          isReseller={isReseller}
          extraPackagesPricing={extraPackagesPricing}
          onChange={onChange}
          value={formValue}
        />
      ) : (
        <div className="text-sm formSectionInput">
          {showSlider && (
            <Slider
              onChange={onChange}
              name={name}
              marks={sliderMarks}
              value={formValue}
              min={0}
              max={Object.keys(sliderMarks).length - 1}
              dotStyle={{ backgroundColor: "red" }}
            />
          )}
          <div className={showSlider ? "mt-10" : ""}>
            {volumeLabel} <span className="font-bold">{formatter.format(volumeValue)}</span>
          </div>
          {!hidePrices && (
            <div className="mt-2">
              {priceLabel} <span className="font-bold">{priceValue}</span>
            </div>
          )}

          {isReseller && !hidePrices && (
            <div className="mt-2">
              {resellerPriceLabel} <span className="font-bold">{resellerPriceValue}</span>
            </div>
          )}

          {!hidePrices && <div className="mt-2 text-xs text-[--text-a40]">{vatMsg}</div>}
        </div>
      )}
    </div>
  );
};

export default DeliveryVolumeSelection;
